<template>
<div class="headerBtnBorder"></div>
</template>

<script>
export default {
    data() {
        return {}
    },
    methods: {},
    created() {},
    mounted() {}
}
</script>

<style lang="scss" scoped>
.headerBtnBorder {
    width: 1px;
    height: 19px;
    border: 2px solid #4975D9;
    margin-top: 4px;
    position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/views/login/components/headerBtnBorder.vue